import {
    createColumnHelper,
} from "@tanstack/react-table";

import CrudActions from "components/crud/CrudActions";

const columnHelper =
    createColumnHelper();


export const partyColumns = ({
    onEdit,
    onDelete,
}) => [

    // =========================================================
    // PARTY CODE
    // =========================================================

    columnHelper.accessor(
        "partyCode",
        {
            id: "partyCode",

            header: "Code",

            cell: (info) => (
                <span
                    className="
                        font-medium
                        text-gray-700
                    "
                >
                    {info.getValue() || "-"}
                </span>
            ),
        }
    ),


    // =========================================================
    // PARTY NAME
    // =========================================================

    columnHelper.accessor(
        "name",
        {
            id: "name",

            header: "Party Name",

            cell: (info) => (
                <span
                    className="
                        font-semibold
                        text-navy-700
                    "
                >
                    {info.getValue() || "-"}
                </span>
            ),
        }
    ),


    // =========================================================
    // TYPE
    // =========================================================

    columnHelper.accessor(
        "type",
        {
            id: "type",

            header: "Type",

            cell: (info) => {

                const value =
                    info.getValue();

                return (
                    <span className="capitalize">
                        {value
                            ? String(
                                value
                            ).replace(
                                /_/g,
                                " "
                            )
                            : "-"}
                    </span>
                );
            },
        }
    ),


    // =========================================================
    // PHONE
    // =========================================================

    columnHelper.accessor(
        "phone",
        {
            id: "phone",

            header: "Phone",

            cell: (info) => (
                <span>
                    {info.getValue() || "-"}
                </span>
            ),
        }
    ),


    // =========================================================
    // STATUS
    // =========================================================

    columnHelper.accessor(
        "status",
        {
            id: "status",

            header: "Status",

            cell: (info) => {

                const status =
                    info.getValue();

                const statusClass =
                    status === "active"
                        ? `
                            border-green-200
                            bg-green-50
                            text-green-700
                          `
                        : status === "prospect"
                            ? `
                                border-blue-200
                                bg-blue-50
                                text-blue-700
                              `
                            : status === "closed"
                                ? `
                                    border-gray-200
                                    bg-gray-50
                                    text-gray-700
                                  `
                                : `
                                    border-red-200
                                    bg-red-50
                                    text-red-700
                                  `;

                return (
                    <span
                        className={`
                            inline-flex
                            rounded-full
                            border
                            px-3
                            py-1
                            text-xs
                            font-semibold
                            capitalize
                            ${statusClass}
                        `}
                    >
                        {status || "-"}
                    </span>
                );
            },
        }
    ),


    // =========================================================
    // ASSIGNED EMPLOYEE
    // =========================================================

    columnHelper.accessor(
        "assignedEmployee.name",
        {
            id: "assignedEmployee",

            header: "Assigned To",

            cell: (info) => {

                const item =
                    info.row.original;

                return (
                    <div>

                        <div
                            className="
                                font-medium
                                text-gray-800
                            "
                        >
                            {
                                info.getValue() ||
                                "-"
                            }
                        </div>

                        {
                            item?.assignedEmployee
                                ?.employeeCode && (

                                <div
                                    className="
                                        text-xs
                                        text-gray-500
                                    "
                                >
                                    {
                                        item
                                            .assignedEmployee
                                            .employeeCode
                                    }
                                </div>

                            )
                        }

                    </div>
                );
            },
        }
    ),


    // =========================================================
    // ACTIONS
    // =========================================================

    columnHelper.display({

        id: "actions",

        header: "Actions",

        cell: ({ row }) => {

            const item =
                row.original;

            return (
                <CrudActions

                    showEdit={
                        typeof onEdit ===
                        "function"
                    }

                    onEdit={
                        onEdit
                            ? () =>
                                onEdit(item)
                            : undefined
                    }

                    editTitle="Edit Party"


                    showDelete={
                        typeof onDelete ===
                        "function" &&
                        item.status !==
                            "inactive"
                    }

                    onDelete={
                        onDelete &&
                        item.status !==
                            "inactive"
                            ? () =>
                                onDelete(
                                    item.id
                                )
                            : undefined
                    }

                    deleteTitle="Deactivate Party"

                />
            );
        },
    }),

];